import * as React from 'react';
import {TextArea, css} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

// TODO: width is currently still broken when not using `&&`
export const Width = () => (
  <TextArea
    label="App feedback"
    defaultValue={EXAMPLE_TEXT}
    css={{width: css.value('350px')}}
  />
);
